import React, { useState, useEffect, useRef, useCallback } from 'react';

import { dateService } from '../../../services/date';

import Carousel from './carousel';

const mockBrands = [
  {
    name: 'Starface',
    description: 'Cruelty free and vegan hydrocolloid pimple patches',
    is_new: true,
  },
  {
    name: 'Hyram',
    description: 'Effective, gentle and sustainable skincare',
    is_new: false,
  },
  {
    name: 'Uoma Beauty',
    description: 'Inclusive, accessible beauty in every shade',
    is_new: true,
  },
  {
    name: 'Ami Cole',
    description: 'Celebrate, not cover, melanin-rich skin',
    is_new: true,
  },
];

const NewOnNarrativ = ({}) => {
  const [brands, setBrands] = useState(mockBrands);

  const brandItems = brands.map((brand, index) => {
    const newBadge = brand.is_new ? <div className="new-brand">new brand</div> : null;

    return (
      <div className="item" key={index}>
        {newBadge}
        <img placeholder="brand image" />
        <hr></hr>
        <div className="info">
          <span className="name">{brand.name}</span>
          <span className="description">{brand.description}</span>
        </div>
      </div>
    );
  });

  return (
    <div className="new-on-narrativ">
      <div
        className="color-gradient"
        style={{
          background:
            'linear-gradient(to top, rgba(255,255,255,1) 0%,rgb(222,222,255) 50%,rgba(255,255,255,1) 100%)',
        }}
      >
        <div className="title">⭐️ New on Narrativ</div>
        <div className="brands">{brandItems}</div>
      </div>
    </div>
  );
};

export default NewOnNarrativ;
